import HomeView from '@/views/HomeView.vue';
import { createRouter, createWebHistory } from 'vue-router';

export default createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
    },
    {
      path: '/data/:params*',
      name: 'data',
      component: () => import('../views/DataView.vue'),
    },
    {
      path: '/database-config',
      name: 'database-config',
      component: () => import('../views/DatabaseConfigView.vue'),
    },
    {
      path: '/connections',
      name: 'connections',
      component: () => import('../views/ConnectionView.vue'),
    },
    {
      path: '/offerings',
      name: 'offerings',
      component: () => import('../views/OfferingsView.vue'),
    },
    {
      path: '/features',
      name: 'features',
      component: () => import('../views/FeatureFlagsView.vue'),
    },
    {
      path: '/users/:uid',
      name: 'users',
      component: () => import('../views/UserView.vue'),
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('../views/ErrorView.vue'),
    },
  ],
});
